export default "__VITE_ASSET__$YclCbB2__"